import { graphql } from 'react-relay';

export const categoryInfoFragment = graphql`
    fragment CategoryInfo_info on CategoryInfo {
        entries {
            ...CategoryInfoEntry_entry
        }
    }
`;
